<template>
  <div>
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
        </el-breadcrumb-item>
        <el-breadcrumb-item>用户中心</el-breadcrumb-item>
        <el-breadcrumb-item>票务订单</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="wrapper">
      <div class="sidebar">
        <div class="avatar">
          <img src="../../assets/images/avatar.jpg" />
          <div class="name">
            <!--<h3>张明翰</h3>-->
            <p>{{ phoneNumShow() }}</p>
          </div>
        </div>
        <ul class="menu">
          <li class="active">
            <router-link to="/account/ticket-order">
              <img src="../../assets/images/icon-ticket-active.png" />
              <span>票务订单</span>
            </router-link>
          </li>
          <li>
            <router-link to="/account/mall-order">
              <img src="../../assets/images/icon-order.png" />
              <span>商城订单</span>
            </router-link>
          </li>
          <li>
            <!--<router-link to="/account/contacts"> @click="goToContacts()"-->
            <router-link to="/account/contacts">
              <img src="../../assets/images/icon-contacts.png" />
              <span>常用联系人</span>
            </router-link>
          </li>
          <!--
          <li>
            <router-link to="/account/profile">
              <img src="../../assets/images/icon-profile.png" />
              <span>个人资料</span>
            </router-link>
          </li>-->
        </ul>
      </div>
      <div class="main">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            v-for="(tabItem, tabIndex) in tabList"
            :key="tabIndex"
            :label="tabItem"
          >
            <ul
              class="order-list"
              v-for="(orderItem, orderIndex) in orderList"
              :key="orderIndex"
            >
              <li @click="goOrderDetail(orderItem)">
                <div class="time">
                  <h3>入园时间 {{ orderItem.intoParkTime }}</h3>
                  <p>
                    数量<span>{{ orderItem.users_info.length }}</span>
                  </p>
                </div>
                <div class="number">
                  <div>
                    <p>下单时间：{{ orderItem.order_time }}</p>
                    <p>订单编号：{{ orderItem.order_id }}</p>
                  </div>
                  <div class="price">
                    ¥<span>{{ orderItem.order_amount }}</span>
                  </div>
                </div>
                <div class="status">
                  <p class="completed" v-if="orderItem.order_status == 0">
                    <img src="../../assets/images/icon-completed.png" /> 已完成
                  </p>
                  <p class="cancelled" v-if="orderItem.order_status == 4">
                    <img src="../../assets/images/icon-cancelled.png" /> 已取消
                  </p>
                  <p class="cancelled" v-if="orderItem.order_status == 10">
                    <img src="../../assets/images/icon-cancelled.png" /> 已退款
                  </p>
                  <p class="cancelled" v-if="orderItem.order_status == 9">
                    <img src="../../assets/images/icon-cancelled.png" />
                    等待退款
                  </p>
                  <p class="cancelled" v-if="orderItem.order_status == 12">
                    <img src="../../assets/images/icon-cancelled.png" />
                    部分退款
                  </p>
                  <p class="cancelled" v-if="orderItem.order_status == 14">
                    <img src="../../assets/images/icon-cancelled.png" /> 退款中
                  </p>
                  <p class="unpaid" v-if="orderItem.order_status == 1">
                    <img src="../../assets/images/icon-unpaid.png" /> 待支付
                  </p>
                  <div>
                    <span
                      class="button"
                      v-if="allowAllRefundAll(orderItem)"
                      @click.stop="refundOrder(orderItem.order_id)"
                      >退整单</span
                    >
                    <span
                      class="button"
                      v-if="orderItem.order_status == 1"
                      @click.stop="cancelOrder(orderItem.order_id)"
                      >取消订单</span
                    >
                    <span
                      class="button"
                      v-if="orderItem.order_status == 1"
                      @click.stop="payOrder(orderItem)"
                      >立即支付</span
                    >
                  </div>
                  <!--
                  <div v-if="orderItem.order_status == 0">
                    <span class="button" @click="goOrderDetail(orderItem)"
                      >查看详情</span
                    >
                  </div>-->
                </div>
              </li>
            </ul>
            <el-pagination
              v-if="orderList && orderList.length > 0"
              background
              layout="prev, pager, next"
              :page-count="pageAll"
              @current-change="currentChange"
            >
            </el-pagination>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <el-dialog
      title="取消提示"
      :visible.sync="cancelDialogVisible"
      width="30%"
      :before-close="cancelHandleClose"
    >
      <p>您确定要取消该订单么？</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="cancelOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退订单提示"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>您确定要退掉吗？退票以后，该票将无法使用，票款将原路退回</p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="refundOrderConfirm">确定</el-button>
      </span>
    </el-dialog>
    <new-pay-pouup
      :payDialogShow="payQrCode"
      :orderId="order_id"
      :orderAmount="order_amount"
      v-on:payPrenterShow="payPrenterShow"
    >
    </new-pay-pouup>
  </div>
</template>
<script>
import order from '@/api/order';
import moment from 'moment';
import { getUsedCount } from '@/setup/convertor';
import routerTo from '@/router/routerTo';
import { phoneHidden } from '@/setup/common';
import user from '@/setup/user';
import NewPayPouup from '@/components/NewPayPouup';
import { mapMutations, mapState } from 'vuex';
export default {
  components: {
    NewPayPouup,
  },
  data() {
    return {
      activeName: 0,
      tabList: ['全部', '待支付', '已完成'],
      current: 0,
      orderList: [],
      orderNumberTotal: 0,
      loadMoreShow: false,
      dialogVisible: false,
      cancelDialogVisible: false,
      payQrCode: false,
      order_id: '',
      order_amount: '',
      pageList: [],
      page: 0,
      pageAll: 0,
    };
  },
  computed: {
    ...mapState({
      isLogin: (state) => state.isLogin,
    }),
    /*
    isLogin() {
      return this.$store.getters.isLogin;
    },*/
  },
  created() {
    if (!this.isLogin) {
      routerTo.toLogin(this.$router, false);
    } else {
      this.getOrderList();
    }
  },
  methods: {
    currentChange(value) {
      this.page = value - 1;
      this.getOrderList();
    },
    handleClick(tab, event) {
      this.current = tab.index;
      this.page = 0;
      this.getOrderList();
    },
    goToContacts() {
      routerTo.toContacts(this.$router, false);
    },
    async getOrderList() {
      this.pageList = [];
      const orderListGet = await order.orderList({
        type: this.current,
        start: this.page,
      });
      let tempOrderList = orderListGet.orders;
      this.orderList = tempOrderList; /*this.orderList.concat(tempOrderList);*/
      this.orderList.forEach((orderItem) => {
        let startTime = orderItem.users_info[0].use_time;
        let endTime = orderItem.users_info[0].use_end_time;
        let startTimeStr = moment(startTime).format('HH时');
        let endTimeStr = moment(endTime).format('HH时');
        let startDay = moment(startTime).format('yyyy-MM-DD');
        let intoPartTime = startDay + '  ' + startTimeStr + '-' + endTimeStr;
        this.$set(orderItem, 'intoParkTime', intoPartTime);
      });
      this.orderNumberTotal = orderListGet.total;
      this.pageAll = Math.ceil(this.orderNumberTotal / 10);
      window.scrollTo(0, 0);
    },
    cancelOrder(orderCode) {
      this.cancelDialogVisible = true;
      this.order_id = orderCode;
    },
    refundOrder(orderCode) {
      this.dialogVisible = true;
      this.order_id = orderCode;
    },
    payOrder(orderItem) {
      console.log('我又点击了么', this.payQrCode);
      //this.payQrCode = true;
      this.order_amount = orderItem.order_amount;
      this.order_id = orderItem.order_id;
      if (parseFloat(this.order_amount) == 0) {
        this.payQrCode = false;
        this.payOrderZero();
      } else {
        this.payQrCode = true;
      }
    },
    async payOrderZero() {
      let that = this;
      const payOrderZeroGet = await order.payOrderZero({
        product_code: process.env.VUE_APP_TICKET_PRODUCT_CODE, //TODO
        order_code: this.order_id,
        pay_channel: 'PO_CASH',
        /*channel_id: '10009'*/
      });
      this.getOrderList();
    },
    goOrderDetail(orderInfo) {
      //去订单详情
      console.log('订单详情', orderInfo);
      routerTo.toOrderDetail(this.$router, false, {
        orderId: orderInfo.order_id,
        orderDate: orderInfo.intoParkTime,
      });
    },
    handleClose() {},
    cancelHandleClose() {
      this.cancelDialogVisible = false;
    },
    async cancelOrderConfirm() {
      //取消订单确认
      const cancelOrder = await order.orderCancel({
        order_id: this.order_id,
      });
      this.cancelDialogVisible = false;
      this.getOrderList();
    },
    async refundOrderConfirm() {
      await order.orderRefund({
        order_code: this.order_id,
      });
      this.dialogVisible = false;
      this.getOrderList();
    },
    payPrenterShow() {
      this.payQrCode = false;
      this.getOrderList(); //支付完成刷新数据
    },
    allowAllRefundAll(orderInfo) {
      let canRefund = localStorage.getItem('can_refund')
        ? localStorage.getItem('can_refund')
        : 0;
      if (canRefund != 1) {
        return false;
      }
      let usedCount = getUsedCount(orderInfo);
      return (
        usedCount.total == usedCount.unUsedCount && orderInfo.order_status == 0
      );
    },
    phoneNumShow() {
      let currentUser = user.getUser();
      if (currentUser != null) {
        let phone = phoneHidden(currentUser.phone);
        return phone;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.wrapper {
  display: flex;
  justify-content: space-between;
  width: 1100px;
  margin: 0 auto;
  padding: 20px 0;
  text-align: left;
}
.sidebar {
  width: 280px;
  padding: 20px 0;
  border-radius: 10px;
  background: #fff;
  .avatar {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding: 0 30px;
    .name {
      margin-left: 16px;
      h3 {
        margin-bottom: 5px;
        font-size: 18px;
      }
    }
  }
  .menu {
    li {
      height: 50px;
      padding: 0 0 0 30px;
      font-size: 16px;
      line-height: 50px;
      a {
        display: block;
        color: #191b26;
      }
      img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
    }
    li.active {
      border-right: 2px solid #31a775;
      color: #31a775;
      background: #f6fcf9;
      a {
        color: #31a775;
      }
    }
  }
}
.main {
  width: 800px;
  .order-list {
    li {
      margin-bottom: 20px;
      padding: 20px 20px;
      border-radius: 10px;
      line-height: 24px;
      background: #fff;
      .time {
        display: flex;
        justify-content: space-between;
        margin-bottom: 6px;
        h3 {
          color: #191b26;
          font-weight: normal;
          font-size: 16px;
        }
        p span {
          margin-left: 6px;
          font-size: 20px;
        }
      }
      .number {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
        color: #515457;
        .price {
          padding-bottom: 10px;
          span {
            margin-left: 6px;
            color: #f15b49;
            font-size: 20px;
          }
        }
      }
      .status {
        display: flex;
        align-items: center;
        justify-content: space-between;
        a {
          margin-left: 10px;
        }
        .button {
          display: inline-block;
          min-width: 90px;
          margin-left: 20px;
          padding: 6px 16px;
          border-radius: 18px;
          color: #fff;
          text-align: center;
          background: #31a775;
        }
        .completed {
          color: #31a775;
        }
        .unpaid {
          color: #f15b49;
        }
        .cancelled {
          color: #9e9e9e;
        }
        img {
          width: 20px;
          height: 20px;
          margin-right: 2px;
        }
      }
    }
    li:hover {
      box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.1);
      cursor: pointer;
    }
  }
  .pagination {
    margin: 40px 0 20px;
    text-align: center;
    a {
      display: inline-block;
      margin: 0 6px;
      padding: 0 8px;
      border: 1px solid #31a775;
      border-radius: 4px;
      color: #31a775;
      line-height: 22px;
      background: #fff;
    }
    a.active {
      color: #fff;
      background: #31a775;
    }
    a.disable {
      border: 1px solid #ccc;
      color: #fff;
      background: #ccc;
      cursor: default;
    }
  }
}
.main /deep/ .el-pagination {
  padding: 20px 0;
  text-align: center;
}
.main /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #31a775;
}
.main /deep/ .el-tabs__header {
  margin: 0 0 20px;
}
.main /deep/ .el-tabs__item {
  height: 43px;
  border: none;
  color: #515457;
  font-size: 16px;
  line-height: 43px;
}
.main /deep/ .el-tabs__item.is-active {
  color: #31a775;
}
.main /deep/ .el-tabs__item:hover {
  color: #31a775;
}
.main /deep/ .el-tabs__active-bar {
  height: 2px;
  background: #31a775;
}
.main /deep/ .el-tabs__nav-wrap::after {
  height: 1px;
}
</style>
